import { useState } from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { useContracts } from "./useContracts";
import { PowerData, SendPowerChangeAPIParams } from "../types/power";
import { 
  default as powerService
} from "../services/power";
import contractActions from '../actions/newActions';

type UsePowerState = "uninitialized" | "fetching" | "selecting" | "submitting" | "success" | "error";


export const usePower = () => {

  const dispatch = useDispatch();
  const { currentContract } = useContracts("electricity");
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const { t } = useTranslation();
  const [status, setStatus] = useState<UsePowerState>("uninitialized");
  const [errorCode, setErrorCode] = useState<number | null>(null);

  const waitingForSignature = currentContract?.waitingForSignature;

  const handleSendPower = async (data: PowerData) => {

    const value: SendPowerChangeAPIParams = {
      power_p1: (data.power || 0) * 1000,
      power_p2: (data.power2 || 0) * 1000,
      power_p3: (data.power3 || 0) * 1000,
      power_p4: (data.power4 || 0) * 1000,
      power_p5: (data.power5 || 0) * 1000,
      power_p6: (data.power6 || 0) * 1000,
      phone: '',
      phone_num: '',
      phone_pre: ''
    };

    let phone = data.phone?.trim() || '';
    if (phone && !phone.startsWith('+')) {
      phone = `+${phone}`;
    }

    const phoneDigits = phone.replace(/[^\d]/g, '');

    let phone_pre = '';
    let phone_num = '';

    if (phoneDigits.length > 9) {
      phone_pre = phoneDigits.slice(0, phoneDigits.length - 9);
      phone_num = phoneDigits.slice(-9);
    } else {
      phone_num = phoneDigits;
    }

    const match = phone.match(/^\+(\d+)/);

    if (phone && match) {
      value.phone = phone;
      value.phone_num = phone_num;
      value.phone_pre = phone_pre;
    }

    setStatus("submitting");
    try {
      const contractName = currentContract?.name
      powerService.sendPowerChange({
        contractName: contractName!,
        value
      })
      .then(async (res) => {
        const { waiting_for_signature } = res.promise.data;
        if (!waiting_for_signature) {
          //TODO: Display 'changes being made' with API returned data
        } else {
          dispatch(contractActions['electricity'].signatureStarted("power"));
        }
        setStatus("success");
      })
      .catch(err => {
        if (axios.isAxiosError(err))  {
          if (err.response?.status === 400) {
            setErrors(err.response?.data.errors);
          }
        }
        setStatus("error");
      })
    } catch (e) {
      if (axios.isAxiosError(e) && e.response) {
        const status = e.response.status;
        const data = e.response.data;

        if (status === 400 && data.errors) {
          setStatus("uninitialized");
          setErrorCode(status);
          setErrors(data.errors);
        } else if (status === 406 && data.error) {
          setStatus("error");
          setErrorCode(status);
          setErrors(data.error);
        } else {
          setStatus("error");
        }
      } else {
        setStatus("error");
      }
    }
  };

  return {
    errors,
    errorCode,
    status,
    waitingForSignature: waitingForSignature?.includes("power") ?? false,
    handleSendPower,
  }

}

export default usePower;